if (!customElements.get("m-testimonial-section")) {
  class MTestimonialSection extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this._onSectionLoad = this._onSectionLoad.bind(this);
      this._onResize = this._onResize.bind(this);
    }

    connectedCallback() {
      this.initSlider();
      window.addEventListener("resize", this._onResize);

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener("shopify:section:load", this._onSectionLoad);
      }
    }

    disconnectedCallback() {
      this.destroySlider();
      window.removeEventListener("resize", this._onResize);

      if (window.Shopify && Shopify.designMode) {
        document.removeEventListener("shopify:section:load", this._onSectionLoad);
      }
    }

    shouldStack() {
      return this.dataset.stackMobile === "true" && window.matchMedia("(max-width: 767px)").matches;
    }

    _onResize() {
      if (this.shouldStack()) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    _onSectionLoad(event) {
      const sectionId = this.closest("[data-section-id]")?.dataset?.sectionId;
      if (!sectionId || !event?.target?.id?.includes(sectionId)) return;
      this.destroySlider();
      this.initSlider();
    }

    initSlider() {
      if (this.slider) return;
      if (this.shouldStack()) return;

      this.swiperContainer = this.querySelector(".m-testimonial-section__swiper");
      if (!this.swiperContainer) return;

      if (typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) {
        requestAnimationFrame(() => this.initSlider());
        return;
      }

      const slides = this.swiperContainer.querySelectorAll(".swiper-slide");
      if (slides.length < 1) return;

      const autoplayEnabled = this.dataset.autoplay === "true";
      const autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
      const prevEl = this.querySelector(".m-testimonial-section__arrow--prev");
      const nextEl = this.querySelector(".m-testimonial-section__arrow--next");
      const paginationEl = this.querySelector(".m-testimonial-section__pagination");

      this.slider = new MinimogLibs.Swiper(this.swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slides.length > 1,
        speed: 500,
        watchOverflow: true,
        autoplay: autoplayEnabled
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        navigation: {
          prevEl,
          nextEl,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    }

    destroySlider() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }
  }

  customElements.define("m-testimonial-section", MTestimonialSection);
}
